<div class="container-table">
  <table>
    <!-- titulo das colunas -->
    <thead>
      <ng-content select="[titulo]">

      </ng-content>
    </thead>
    <!-- o conteudo da tabela -->
    <tbody>
      <ng-content select="[linhas]"></ng-content>

    </tbody>
  </table>
</div>
